<script setup lang="ts">
import { useAppStore } from '@/store/app/app'
import { useToggleStore } from '@/store/toggle/toggle'

import { AsyncDataKey } from '@/types/main'

import MainCategoryLink from '@/components/Main/Category/MainCategoryLink.vue'

const { data: simpleCategories } = useNuxtData(
  AsyncDataKey.SIMPLE_CATEGORIES_DATA,
)

const appStore = useAppStore()
const { isLandingPageEnabled } = useToggleStore()

const isScrollTriggerActive = computed(() => {
  return isLandingPageEnabled && appStore.activeCategorySlug
})
</script>

<template>
  <div class="menu-categories">
    <the-slider
      :space-between="24"
      :slide-width="80"
      :arrows-offset="-32"
      :scroll-trigger="isScrollTriggerActive ? appStore.activeCategorySlug : ''"
      slide-class="main-category-link"
      slide-active-class="main-category-link--active"
      is-different-width
    >
      <main-category-link
        v-for="category in simpleCategories"
        :key="category.slug"
        :category="category"
      />
    </the-slider>
  </div>
</template>

<style lang="scss" scoped>
.menu-categories {
  height: 100%;
  padding: 11px 24px;

  @include media('>=desktop') {
    max-width: 1200px;
    padding: 15px 0;
    margin: 0 auto;
  }
}
</style>
